import { Component, OnInit } from '@angular/core';
import { ConfigEntities } from 'src/app/core/models/config-entities';
import { ConfigEntityService } from 'src/app/core/services/config-entity.service';
import { NavigationService } from '../../../../core/services/navigation.service';
import { AuthenticationService } from '../../../../core/services/authentication.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { UpdateAuthenticationConfigurationComponent } from '../update-authentication-configuration/update-authentication-configuration.component';
import { HeaderService } from '../../../../core/services/header.service';
import { UpdateLoginUiConfiguratorComponent } from '../update-login-ui-configurator/update-login-ui-configurator.component';
import { ServiceBroadcast } from '../../../../core/models/serviceBroadcast';
import { ServiceBroadcastComponent } from '../service-broadcast/service-broadcast.component';
import { SubEntities } from 'src/app/core/models/globals';

@Component({
  selector: 'app-configurator-main-panel',
  templateUrl: './configurator-main-panel.component.html',
  styleUrls: ['./configurator-main-panel.component.scss']
})

export class ConfiguratorMainPanelComponent implements OnInit {
  configEntities: ConfigEntities[];

  lastRefreshedTime: Date; // time when data is loaded/refreshed
  depName: string;
  cloudType: string;
  activeEntity: string;
  universalSub: Subscription;

  constructor(
    private configEntityService: ConfigEntityService,
    private navService: NavigationService,
    private authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private router: Router,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private headerService: HeaderService
  ) { }

  ngOnInit(): void {
    this.navService.subNavData('Configurator')
    this.navService.sendLastUpdate(this.headerService.getUserNewDate());
    this.universalSub = this.navService.lastUpdateTime.subscribe((x) => {
      this.lastRefreshedTime = x;
    });
  }

  ngOnDestroy(): void {
    this.navService.subNavData('')
    if(this.universalSub) this.universalSub.unsubscribe()
  }

  refreshComponent() {
    let url = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([decodeURI(url)]);
    });
  }
}
